import {
    FAVOURITE_SELLERS,
    LAST_CHANCE,
    RECENTLY_VIEWED,
    SAVED_SEARCHES,
    WISH_LIST,
    RESELL_SUGGESTIONS,
} from 'tradera/apps/tradera/start-page/content-types';

const DEFAULT_START_PAGE_HEADER_CONFIG = {
    alternativeText: '',
    backgroundImage: null,
};

export const DEFAULT_LOGGED_IN_START_PAGE_CONFIG = {
    header: DEFAULT_START_PAGE_HEADER_CONFIG,
    content: [
        { type: RESELL_SUGGESTIONS },
        { type: WISH_LIST },
        { type: SAVED_SEARCHES },
        { type: FAVOURITE_SELLERS },
        { type: LAST_CHANCE },
        { type: RECENTLY_VIEWED },
    ],
};

export const DEFAULT_LOGGED_OUT_START_PAGE_CONFIG = {
    header: DEFAULT_START_PAGE_HEADER_CONFIG,
    content: [{ type: LAST_CHANCE }, { type: RECENTLY_VIEWED }],
};
